import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-top: 64px;
  padding: 40px 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    margin-top: 128px;
    flex-direction: row;
  }
`;

export const Illustration = styled.img`
  max-width: 259px;
  height: auto;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;
